import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  clone(id, data = {}) {
    return axios.post(`${this.url}/${id}/clone`, data);
  }
}

export default new CampaignsAPI();
